import extendDefaults from "@giantpeach/extend-defaults";
import throttle from "lodash.throttle";

function moveitItem(el) {
    var style = window.getComputedStyle(el),
        rect = el.getBoundingClientRect();

    this.el = el;
    this.style = style;
    this.speed = parseFloat(this.el.getAttribute("data-scroll-speed"));
    this.mode = this.el.getAttribute("data-moveit-mode");
    this.direction = this.el.getAttribute("data-moveit-direction");
    this.rect = rect;
    this.offset = {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft,
        offsetHeight: this.el.offsetHeight,
        offsetWidth: this.el.offsetWidth,
    };

    if (!this.speed) {
        this.speed = 5;
    }

    if (!this.mode) {
        this.mode = "default";
    }

    if (!this.direction) {
        this.direction = "down";
    }

    this.origTranslateX = 0;
    this.origTranslateY = 0;

    if (
        style.getPropertyValue("transform") != "none" &&
        style.getPropertyValue("transform") != null
    ) {
        var transformMatrix = style.getPropertyValue("transform").split(",");
        this.origTranslateX = parseFloat(transformMatrix[4]);
        this.origTranslateY = parseFloat(transformMatrix.slice(0, -1));
    } else {
        this.el.style.transform = "translate3d(0px, 0px, 0px)";
    }

    this.centerYPos = this.offset.top + this.offset.offsetHeight / 2;
    this.centerXPos = this.offset.left + this.offset.offsetWidth / 2;

    this.window = {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
    };
}

moveitItem.prototype.applyStyles = function (item, x, y, z) {
    throttle(function () {
        item.el.style.transform =
            "translate3d(" + x + "px, " + y + "px, " + z + "px)";
    }, 16)();
};

moveitItem.prototype.down = function (that) {
    var item = this;
    var scrollTop = 0;

    if (that == window) {
        that = document.body;
        scrollTop = window.scrollY;
    } else {
        scrollTop = that.scrollTop;
    }

    var start = item.offset.top - (item.window.innerHeight / 2) * 3,
        end =
            item.offset.top +
            item.offset.offsetHeight +
            item.window.innerHeight / 2;

    if (scrollTop > start && scrollTop < end) {
        var windowCenter = scrollTop + item.window.innerHeight / 2,
            scrollDiff = windowCenter - item.centerYPos,
            pos = (-1 * scrollDiff) / item.speed + item.origTranslateY;

        if (scrollDiff < 0) {
            if (item.mode != "after-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, item.origTranslateX, pos, 0);
                });
            }
        } else {
            if (item.mode != "before-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, item.origTranslateX, pos, 0);
                });
            }
        }
    }
};

moveitItem.prototype.right = function (that) {
    var item = this;

    var start = item.offset.left - (item.window.innerWidth / 2) * 3,
        end =
            item.offset.left +
            item.offset.offsetWidth +
            item.window.innerWidth / 2;

    if (that.scrollLeft > start && that.scrollLeft < end) {
        var windowCenter = that.scrollLeft + item.window.innerWidth / 2,
            scrollDiff = windowCenter - item.centerXPos,
            pos = (-1 * scrollDiff) / item.speed + item.origTranslateX;

        if (scrollDiff < 0) {
            if (item.mode != "after-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, pos, item.origTranslateY, 0);
                });
            }
        } else {
            if (item.mode != "before-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, pos, item.origTranslateY, 0);
                });
            }
        }
    }
};

moveitItem.prototype.update = function (that) {
    if (this.direction == "down") {
        this.down(that);
    } else if (this.direction == "right") {
        this.right(that);
    }
};

function moveit(opt) {
    var instances = [],
        elements,
        i = 0;

    this.options = {
        selector: ".moveit",
        scrollContainer: window,
    };

    if (typeof opt === "object") {
        extendDefaults(this.options, opt);
    }

    elements = document.querySelectorAll(this.options.selector);
    console.log({ elements });

    for (i = 0; i < elements.length; i++) {
        instances.push(new moveitItem(elements[i]));
    }

    var that = this;

    this.options.scrollContainer.addEventListener("scroll", function () {
        if (that.options.scrollContainer == window) {
            that.scrollTop = document.body.scrollTop;
            that.scrollLeft = document.body.scrollLeft;
        } else {
            that.scrollTop = that.options.scrollContainer.scrollTop;
            that.scrollLeft = that.options.scrollContainer.scrollLeft;
        }

        for (i = 0; i < instances.length; i++) {
            instances[i].update(that.options.scrollContainer);
        }
    });
}

export default moveit;



// WEBPACK FOOTER //
// ./js/util/moveit.js